import axios from "axios";

const API_BASE = process.env.REACT_APP_COLLEGE_ERP_API;

/**
 * Reusable function to create or update book data
 * @param {string} baseUrl - API endpoint
 * @param {object} formData - Data to submit (e.g., updated book info)
 * @param {object} options - { branch, token, editData }
 * @returns {Promise<object>} response data
 */
export const submitBooksData = async (baseUrl, formData, { branch, token, editData }) => {
  const method = editData ? "PUT" : "POST";

  try {
    const response = await axios({
      method,
      url: baseUrl,
      params: { branch },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: formData,
    });

    return response.data;
  } catch (error) {
    console.error("Book submission failed:", error);
    throw error;
  }
};

/**
 * Fetch transactions for a given member
 * @param {string} branch
 * @param {string} memberId
 * @param {string} token
 * @returns {Promise<Array>} Member transaction data
 */
export const fetchMemberTransactions = async (branch, memberId, token) => {
  try {
    const response = await axios.get(`${API_BASE}library_transaction_member_id`, {
      params: { branch, Member_ID: memberId },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching member transactions:", error);
    throw error;
  }
};

/**
 * Fetch member details using mobile number
 * @param {string} branch
 * @param {string} mobileNo
 * @param {string} token
 * @returns {Promise<Array>} Array of member objects
 */
export const fetchMemberDetailsByMobile = async (branch, mobileNo, token) => {
  try {
    const response = await axios.get(`${API_BASE}library_member_mobile`, {
      params: { branch, mobileNo },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching member details:", error);
    throw error;
  }
};
